{
  "deselectedItem": "{item} не е избран.",
  "select": "Изберете",
  "selectedAll": "Всички елементи са избрани.",
  "selectedCount": "{count, plural, =0 {Няма избрани елементи} one {# избран елемент} other {# избрани елементи}}.",
  "selectedItem": "{item} избран."
}
